import config from "./config";

// Role groupings for route-level authorization. A PrivateRoute declares which
// roles may view it via `allowedRoles={...}`; if a logged-in user's usertype
// isn't in the list, PrivateRoute renders the Unauthorized page instead.
//
// Each route declares its own audience here rather than gating inside the
// component, so a per-role dashboard variant (teacher/principal — a thin
// container over the same pages) is a route entry, not a branch in the view.
export const ADMIN_ROLES = [
  config.SUPERADMIN_USERTYPE,
  config.ORGADMIN_USERTYPE,
  config.ORGUNITADMIN_USERTYPE,
];

// The default landing dashboard for a user, by role. Mirrors the role-based
// redirects in LoginForm / the SSO callbacks / App.reroute so the Unauthorized
// page can offer a "go to your dashboard" escape hatch. Returns "/login" for a
// null user and "/" for an unrecognized role.
export const dashboardPathForUser = (user) => {
  if (!user) return "/login";
  switch (user.usertype) {
    case config.TEACHER_USERTYPE:
      return user.organization &&
        user.organization.category === config.ABII_HOME.toLowerCase()
        ? "/home/dashboard"
        : "/teacher/dashboard";
    case config.ORGADMIN_USERTYPE:
    case config.ORGUNITADMIN_USERTYPE:
      return "/admin/dashboard";
    case config.SUPERADMIN_USERTYPE:
      return "/super/dashboard";
    case config.LEARNER_USERTYPE:
      return "/learner/dashboard";
    default:
      return "/";
  }
};
